import styled, { css } from 'styled-components';
import { Row, Col } from 'antd';
import { SecondaryButtonComponent, LinkTo } from "../../../../CommonComponents/commonStyles";

export const HowItWorksWrapper = styled.div`
  margin-left: 140px;
  margin-right: 145px;
  color: ${props => props.theme.fontColors.textColor};
  && .tooltiptext-i {
    letter-spacing: ${props => props.theme.letterSpacing.zero};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  && .main-max-width-container {
    padding: 0px;
  }
  @media only screen and (max-width: 767px) {
  margin-left: 22px;
  margin-right: 22px;
  }
`;
export const HowItWorksMainHead = styled.h1`
  height: 48px;
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h1};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h1};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  margin-top: 50px;
  @media only screen and (max-width: 767px) {
    width: 316px;
    height: 84px;
    object-fit: contain;
    font-size: ${props => props.theme.fontSize.h2};
    line-height: ${props => props.theme.lineHeight.h2};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-top : 40px;
    margin-bottom: 0px;
  }
`;
export const HowItWorksTitle = styled(Row)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.textColor};
  max-width: 963px;
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
    margin-top: 5px;
  }
`;
export const HowItWorksStepRectangle = styled.div`
  height: auto;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
  border: solid 1px #eaeaea;
  background-color: ${props => props.theme.backgroundColor.layoutLight};
  `;  
export const HowItWorksStepWrapper = styled.div`
  height:auto;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
  border: solid 1px #eaeaea;
  background-color: ${props => props.theme.backgroundColor.layoutLight};
  position: relative;
  padding-bottom: 0px;
  @media only screen and (min-width:768px) and (max-width: 1375px) {
    && .howitWorksStepsImage {
      width: calc(100% - 157px);
    }
  }
  @media only screen and (min-width:768px) and (max-width: 1024px) {
    && .howitWorksStepsImage {
      width: calc(100% - 88px);
    }
  }
`;
export const StepsTitle = styled.div`
  height: 30px;
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color:${props => props.theme.backgroundColor.tealBlue};
  margin-left: 50px;
  margin-top: 40px;
`;
export const StepsMainHead = styled.div`
  height: auto;
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h2};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h2};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  margin-left: 50px;
  margin-top: 15px;
  `;
export const StepsDescription = styled.div`
  margin-right: 20px;
  height: auto;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.textColor};
  margin-left: 50px;
  overflow-wrap: break-word;
  margin-top: 15px;
  max-width: 963px;
  @media only screen and (min-width:768px) and (max-width:1366px) {
    margin-right: 20px;
  }
`;

export const LinkToSamll = styled(LinkTo)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary} !important;
  @media only screen and (min-width: 992px) {
    font-size: ${props => props.theme.fontSize.primary} !important;  
  }
`;

export const ShowMoreShowLessButton = styled.div`
  width: 134px;
  height: 30px;
  border-radius: 18px;
  border: solid 1px #d4d4d4;
`;
export const ShowDataButton = styled(SecondaryButtonComponent)`
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  width: auto;
  margin-left: 50px;
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  &.prfShowMore {    
    width: 100% !important;
  }
  @media only screen and (max-width: 767px) {
    margin-bottom: 0px;
  }
  @media only screen and (max-width: 830px) {
    &.prfShowMore {    
        width: 88% !important;
        font-size: 10px;
    }
  }
  @media only screen and (max-width: 767.92px) {
    width: auto;    
  }
  @media only screen and (max-width: 576px) {
    width: auto;
  }
  @media only screen and (max-width: 767px) {
    margin-left: 20px;
  }   
`;
export const StepsQuestion = styled.div`
  height: auto;
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h3};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h3};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  margin-left: 50px;
  margin-top: 50px;
  margin-right: 50px;
  @media only screen and (max-width: 767px) {
    margin-left: 20px;
    font-size: ${props => props.theme.fontSize.h4};
    line-height: ${props => props.theme.lineHeight.h4};
  }
  @media only screen and (max-width: 480px) {
    margin-left: 20px;
    margin-right: 20px;
  }
`;
export const StepsAnswer = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.textColor};
  margin-left: 50px;
  margin-top: 15px;
  margin-right: 50px;
  @media only screen and (min-width: 1375px) {
    margin-right: 147px;
  }
  @media only screen and (max-width: 767px) {
    margin-left: 20px;
    font-size: ${props => props.theme.fontSize.secondary};
  }
  @media only screen and (max-width: 480px) {
    margin-left: 20px;
    margin-right: 20px;
    overflow-wrap: break-word !important;
  }
  &.stepAnswers ul li, &.stepAnswers ol li {
    font-family: ${props => props.theme.fontFamily.berkeleyStd};
  }
`;
export const StepStatusDot = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 12.5px;
  border: solid 5px #d4d4d4;
  background-color: ${props => props.theme.backgroundColor.tealBlue};
  left: 49.3%;
  position: relative;
`;

export const FirstStatusAfterIssuingGrant = styled.div`
  width: auto;
  height: 30px;
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  position: absolute;
  @media only screen and (max-width: 768px) {        
      font-size: 21px;        
  }
  @media only screen and (min-width:767px) and (max-width:768px) {
    font-size: 21px;
    padding-left: 15px;
  }
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    padding-left: 6px;
  }
`;
export const SecondStatusAfterIssuingGrant = styled.div`
  width: auto;
  height: 30px;
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  position: absolute;
  @media only screen and (max-width: 768px) {        
    font-size: 21px;        
  }
  @media only screen and (min-width:767px) and (max-width:768px) {
    font-size: 21px;
    padding-left:15px;
  }
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    padding-left: 6px;
  }
`;
export const StatusDescriptionAfterIssuingGrant = styled.div`
  width: 242px;
  height: 84px;
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h2};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h2};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  text-align: right;
  color: ${props => props.theme.fontColors.headingColor};
  position: absolute;
  right: 0px;

`;

export const FirsrtStatusAfterResearch = styled.div`
  width: auto;
  height: 30px;
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color:#022737;
  position: absolute;
  @media only screen and (min-width:767px) and (max-width:768px) {
    font-size: 21px;
    padding-left: 15px;
  }
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    padding-left: 6px;
  }
`;
export const StatusDescriptionAfterResearch = styled.div`
  height: 84px;
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h2};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h2};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  text-align: right;
  color: ${props => props.theme.fontColors.headingColor};
  position: absolute;
  right: 0px;
  width: 392px; 
  @media (max-width:1024px) and (min-width:767px) {
    width: auto;
  }​
  @media (min-width:1024px) and (max-width:1216px) {
    width: auto;
  }​
  @media screen and (min-width: 1024px) {
    width: 447px;
  }
`;
export const FirstStatusAfterRecommend = styled.div`
  width: auto;
  height: 30px;
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  position: absolute;
  width: auto;
  @media only screen and (min-width:767px) and (max-width:768px) {
    font-size: 21px;
    padding-left: 15px;
  }
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    padding-left: 6px;
  }
`;
export const StatusDescriptionAfterRecomend = styled.div`
  width: 392px;
  height: 84px;
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h2};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h2};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  text-align: right;
  color: ${props => props.theme.fontColors.headingColor};
  position: absolute;
  right: 0px;
  @media (max-width:1024px) and (min-width:767px) {
    width: auto;
  }​
`;

// Mobile  View Starts
export const HowItWorksMobileView = styled.div`
`;
export const HowItWorksStepMobile = styled.div`
  width: 45px;
  height: 45px;
  border-radius: 33px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  border: solid 5px #d4d4d4;
  background-color: ${props => props.theme.backgroundColor.tealBlue};
  position: absolute;
  z-index: 1;
  top:-24px;
  left: 20px;
`;

// common
export const HowItWorksStep = styled.div`
  width: 17px;
  height: 36px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.h3};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.colors.white};
  margin-top: 8px;
  margin-left: 19px;
`;

export const StepsTitleMobile = styled.div`
  width: 65px;
  height: 30px;
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h5};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.backgroundColor.tealBlue};
  margin-left: 20px;
  margin-top: 30px;
`;
export const StepsCount = styled.div`
  width: 17px;
  height: 36px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: 30px;
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.colors.white};
  margin-top: 8px;
  margin-left: 19px;
  @media only screen and (max-width: 767px) {
    height: 28px;
    font-size: ${props => props.theme.fontSize.h4};
    margin-top: 3px;
    margin-left: 11px;
  } 
`;
export const StepsMainHeadMobile = styled.div`
  height: auto;
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h3};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h3};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  margin-left: 20px;
  margin-top: 15px;
`;
export const StepsDescriptionMobile = styled.div`
  height: auto;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.textColor};
  margin-left: 20px;
  overflow-wrap: break-word;
  margin-top: 15px;
  margin-right: 20px;
 `;
export const VerticalLineDesktop = styled.div`
  border-left: 6px solid black; 
  height: 50px; 
  position:absolute; 
  border: solid 2px #d4d4d4;
  position: absolute;
  z-index: 0;
  left: calc(50% - -4px);
`;
export const VerticalLineDesktopRel = styled.div`
  border-left: 6px solid black; 
  height: 50px; 
  position:absolute; 
  width: 2px;
  border: solid 2px #d4d4d4;
  position: relative;
  z-index: 0;
  left: calc(50% - -4px);
`;
export const VerticalLineMobile = styled.div`
  border-left: 6px solid black; 
  height: 52px; 
  position:absolute; 
  left: 41px;
  width: 1px;
  border: solid 1.5px #d4d4d4;
  position: absolute;
  z-index: -1;
`;
export const VerticalLineShorter = styled.div`
  border-left: 6px solid black; 
  height: 52px; 
  position:absolute; 
  left: 41px;
  width: 1px;
  border: solid 1.5px #d4d4d4;
  position: absolute;
  z-index: -1;
  @media only screen and (max-width: 767px) {
    height: 30px;
  }
`;
export const VerticalLineMobileLong = styled.div`
  border-left: 6px solid black; 
  height: 168px; 
  left: 41px;
  width: 1px;
  border: solid 1.5px #d4d4d4;
  z-index: 0;
  position: relative;
`;
export const StatusDescriptionAfterStepsMobile = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h3};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h3};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  text-align: left;
  color: ${props => props.theme.fontColors.headingColor};
  margin-left: 76px;
  position: absolute;
  top: -128px;
  @media (max-width: 767px) {
    max-width: 255px;
    min-height: 84px;
  }
  @media (max-width: 409px) {
    top: -150px;
  }
`;
export const TimelineDot = styled.div`
  position: relative;
  width: 25px;
  height: 25px;
  border-radius: 12.5px;
  border: solid 5px #d4d4d4;
  background-color: ${props => props.theme.backgroundColor.tealBlue};
  text-align: center;
  left: calc(50% - 5px);
`;
export const TimelineDotMobile = styled.div`
  left: 34px;
  position: relative;
  width: 18px;
  height: 18px;
  border-radius: 12.5px;
  border: solid 1.5px #d4d4d4;
  background-color: ${props => props.theme.backgroundColor.tealBlue};
  text-align: center;
`;
export const FirstStatusAfterRecommendMobile = styled.div`
  margin-left: 76px;
  top: -24px;
  height: 26px;
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h5};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  position: absolute;
`;
export const SecondStatusAfterIssuingGrantMobile = styled.div`
  padding-top: 6px;
  margin-left: 76px;
  height: 30px;
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h5};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
`;
export const InternationalGrantingDiv = styled(Col)`
  width: calc(50% - 3px);
  min-height: 289px;
  height: auto;
  border: solid 5px ${props => props.theme.border.teal};
  @media only screen and (max-width: 767px) {
    width: 100%;
    border: solid 2px ${props => props.theme.border.teal};
  }
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    width: calc(50% - 7px);
    padding-bottom: 30px;
  }
`;
export const GrantAgreementHead = styled.div`
  height: auto;
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h2};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h2};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  text-align: center;
  margin-top: 40px;
  @media only screen and (max-width: 767px) {
    width: 100%;
    line-height: ${props => props.theme.lineHeight.h3};
    font-size: ${props => props.theme.fontSize.h3};
  }
  @media only screen and (max-width: 332px) {
    height: auto;
  }
`;
export const GrantDescription = styled.div`
  height: auto;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  text-align: center;
  color: ${props => props.theme.fontColors.textColor};
  margin-top: 12px;
  margin-left: auto;
  max-width: 490px;
  position: relative;
  margin-right: auto;
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
    padding-left: ${props => props.theme.spacing.paddings.paddingDesLeft};
    padding-right: ${props => props.theme.spacing.paddings.paddingDesRight};
    padding-bottom: ${props => props.theme.spacing.paddings.mdPadding};
  }
`;
export const GrantAgreementDiv = styled(Col)`
  width: calc(50% - 17px);
  min-height: 289px;
  height: auto;
  border: solid 5px ${props => props.theme.border.tealBlue};
  @media only screen and (max-width: 767px) {
    margin-top: 20px;
    width: 100%;
    border: solid 2px ${props => props.theme.border.tealBlue};
  }
  @media only screen and (min-width: 767px) and (max-width: 991px) {
    padding-bottom: 30px;
    width: calc(50% - 7px);
    left: 5px;
  }
`;
export const HorizontalLine = styled.div`
  height: 1px;
  border: solid 1px #d4d4d4;
  margin-top: 49.5px;
  margin-left: 50px;
  margin-right: 50px;
  @media only screen and (max-width: 767px) {
    height: 1px;
    border: solid 1px #d4d4d4;
    margin-top: 39px;
    margin-left: 20px;
    margin-right: 20px
  }
`;
export const focusDiv = {
  marginTop: '9px',
  height: '21px'
}
export const RelativeDiv = styled.div`
  position: 'relative'
`;
export const GrantWrapper = {
  marginTop: '52px'
}
export const timelineDot = {
  top: '30px'
}
export const StepCountWrapper = styled(Col)`
  width: 66px;
  height: 66px;
  border-radius: 33px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  border: solid 5px #d4d4d4;
  background-color: ${props => props.theme.backgroundColor.tealBlue};
  position: absolute;
  z-index: 1;
  top:-31px;
  left: calc(50% - 27px);
`;
export const breadCrumFont = {
  color: '#505050'
}
export const HowItWorksBreadCumbWrapper = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
`;

export const LoaderWrapper = styled.div`
  height: 70vh;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
`;
export const colMinHeight = {
  minHeight: '0px'
};
export const HowItWorksBody = styled.div`
  a {    
    color: ${props => props.theme.fontColors.primary}
    text-decoration: underline;
  }
`;
export const AccordionWrapper = styled.div`
  width: 100%;
  @media only screen and (min-width: 768px) {
    cursor: pointer;
  }
`;
export const FocusDiv = styled.div`
  marginTop: 9px;
  height: 21px;
  &&.focusExpanded:hover {
    cursor: default !important;
  }
  &&.focusCollapsed:hover {
    cursor: pointer !important;
  }
`;